import { apiPost } from '../../api'

export const save_billing = data =>
  apiPost({
    endpoint: 'kyc/save_billing',
    data: data
  })
